import { makeStyles } from '@material-ui/styles';
import { white } from '../../../constants/Colors';

export default makeStyles(() => ({
    tooltip: {
        fontSize: '14px',
        color: white,
        background: '#1A1A1A',
        border: 'none',
        borderRadius: '0',
        boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
    },
}));
